<img alt="ghost-hand" id="ghosthand-click" src="assets/images/ghosthand.png">
